import React from "react";

const ErrorPage = () => {
  return <div>Error in Page routing</div>;
};

export default ErrorPage;
